import { Chip } from '@/shared/ui';

type PriceInfoProps = {
	fuelType: '휘발유' | '경유';
	currentPrice?: number;
	averagePrice?: number;
	region?: string;
};

const PriceInfo = ({
	fuelType,
	currentPrice,
	averagePrice,
	region,
}: PriceInfoProps) => {
	const chipClassNames = {
		휘발유: 'text-mantang-indigo bg-mantang-bg-blue',
		경유: 'text-mantang-red bg-mantang-bg-red',
	}[fuelType];

	return (
		<div className="flex flex-1 flex-col items-center gap-2">
			<Chip className={chipClassNames}>{fuelType}</Chip>
			<p className="font-semibold text-base text-mantang-black">
				{Math.floor(currentPrice ?? 0).toLocaleString('ko-KR')}원
			</p>
			<p className="font-light text-mantang-gray-500 text-xs">
				{region
					? `${region} 평균 ${Math.ceil(averagePrice ?? 0).toLocaleString('ko-KR')}원`
					: ''}
			</p>
		</div>
	);
};

export default PriceInfo;
